/* eslint-disable */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable max-len */
import React, { useState, useEffect, useMemo } from 'react';
import Arrow from 'src/assets/arrow-left-black.svg';
import {
  CommonDropdown,
  CommonInput,
  FormErrorWrap,
  RegularButton,
  ICommonDropdownOption,
  FullScreenLoading,
  OutlinedButton,
  DatePicker,
} from 'pg-ui-library';

import {
  Container,
  CardContainer,
  HelpForm,
  PageTitle,
  FormInputWrapper,
  NavTextLink,
  ArrowBack,
  HeaderItemLeft,
  ModuleLine,
  SearchLink,
} from './createStyles';
import { useFormik, FormikErrors } from 'formik';
import * as yup from 'yup';
import { AssignmentApiItem } from 'src/interfaces/invoice';
import { Link, useNavigate } from 'react-router-dom';
import { useLocalStorage } from 'src/hooks/useLocalStorage';
import { useQuery } from '@tanstack/react-query';
import InvoiceService from 'src/services/invoice.service';
import WorkWeekDatepicker from 'src/components/work-week-datepicker';
import UploadLink from 'src/components/upload-link';
import EmployeesService, { IEmployeeDropdown } from 'src/services/employees.service';
import { ExpenseFormValues } from 'src/interfaces/expense';
import { useAddExpense } from './mutations/expense.mutation';
import { currencySymbol } from 'src/utils/currency';
import { toISODate } from 'src/utils/expenseDate';

interface AssignmentItem {
  ASSIGNMENT_ID: string;
  JOBTITLE: string;
  CLIENT_NAME: string;
  EMPLOYEEID: string;
  WORKER_PAY_COMPANY?: string;
  HIRETYPE?: string;
  BILL_RATE?: number;
  PAY_RATE?: number;
  CURRENCY?: string;
  ASSIGNMENT_APPROVER_NAME?: string;
  APPROVER_EMAIL?: string;
  COMPANY_ID?: string;
  JOB_CLIENT_ID?: string;
  COMPANY_NAME?: string;
  EMPLOYMENT_CATEGORY?: string;
  BILLING_CONTACT_NAME?: string;
  WORKING_CITY?: string;
  WORKING_STATE?: string;
  ADDRESS1?: string;
  PAY_OVERTIME_EXEMPT?: string;
  OVERTIME_PAY_RATE?: string;
  HOURSPERWEEK?: string;
  CONTRACT_START_DATE?: string;
  CONTRACT_END_DATE?: string;
  MANAGER_NAME?: string;
  MANAGER_EMAIL?: string;
  BACKUP_APPROVER_NAME?: string;
  BACKUP_APPROVER_EMAIL?: string;
  ASSIGNMENT_TYPE?: string;
  PAY_MODEL?: string;
  EXPENSES_ENABLED?: string;
  CANDIDATE_CITY?: string;
  CANDIDATE_STATE?: string;
  assignmentStartDate: Date | null;
  assignmentEndDate: Date | null;

  DIVISION?: string;
  OVERTIME?: string;
  OT_CALCULATION?: string;
  OVERTIMEELIGIBILITY?: string;

  MARKUP_PERCENT?: string;
  W2_TYPE?: string;
  WORKMODE?: string;

  COST_CENTER_ID?: string;
  COST_CENTER_NAME?: string;

  Departments?: string;

  MERID?: string;
  PURCHASE_ORDER?: string;

  BILLING_COMPANY?: string;

  BILLING_ADDRESS1?: string;
  BILLING_ADDRESS2?: string;

  BILLING_CITY?: string;
  BILLING_STATE?: string;
  BILLING_COUNTY?: string;
  BILLING_COUNTRY?: string;

  POSTAL_CODE?: string;

  BILL_ADDRESS_SAME_AS_WORK_ADDRESS?: string;
  STATUS?: string;
  ASSIGNMENT_STATUS?: string;
  BILLING_ZIP?: string;
  GL_CODE?: string;
  VMS_ID?: string;
}

const commonFieldStyle = {
  width: '100%',
  height: '35px',
  borderRadius: '7px',
  border: '1px solid #ccc',
  paddingTop: '2px',
  paddingBottom: '2px',
  boxSizing: 'border-box',
  fontSize: '1.5rem',
} as const;

interface ExpenseRow {
  expenseDate: string;
  category: string;
  amount: string;
  receipt: File | null;
  details: string;
}

const expenseCategories = [
  { name: '', displayName: 'Select' },
  { name: 'AIRFARE', displayName: 'Airfare' },
  { name: 'LODGING', displayName: 'Lodging' },
  { name: 'MEAL', displayName: 'Meal' },
  { name: 'MATERIALS', displayName: 'Materials' },
  { name: 'MILEAGE', displayName: 'Mileage' },
  { name: 'MOBILE', displayName: 'Mobile Device' },
  { name: 'PARKING', displayName: 'Parking/Toll' },
  { name: 'TRANSPORT', displayName: 'Local Transportation' },
  { name: 'OTHER', displayName: 'Other' },
];

const formatOptionLabel = (date: Date) => {
  const dayName = date.toLocaleDateString('en-US', { weekday: 'short' });
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const yyyy = date.getFullYear();

  return `${dayName} ${mm}/${dd}/${yyyy}`;
};

const formatOptionValue = (date: Date) => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');

  return `${yyyy}-${mm}-${dd}`;
};

const getWeekDateOptions = (selectedDate: Date, minDate?: Date | null, maxDate?: Date | null) => {
  const current = new Date(selectedDate);
  const day = current.getDay();
  const diffToMonday = day === 0 ? -6 : 1 - day;

  const monday = new Date(current);
  monday.setHours(0, 0, 0, 0);
  monday.setDate(current.getDate() + diffToMonday);

  const normalizedMinDate = minDate ? new Date(minDate) : null;
  const normalizedMaxDate = maxDate ? new Date(maxDate) : null;

  if (normalizedMinDate) normalizedMinDate.setHours(0, 0, 0, 0);
  if (normalizedMaxDate) normalizedMaxDate.setHours(0, 0, 0, 0);

  return Array.from({ length: 7 }, (_, index) => {
    const date = new Date(monday);
    date.setDate(monday.getDate() + index);
    date.setHours(0, 0, 0, 0);

    return date;
  })
    .filter(date => {
      if (normalizedMinDate && date < normalizedMinDate) return false;
      if (normalizedMaxDate && date > normalizedMaxDate) return false;
      return true;
    })
    .map(date => ({
      key: formatOptionValue(date),
      value: formatOptionValue(date),
      label: formatOptionLabel(date),
    }));
};

const getWorkWeekStartEnd = (date: Date) => {
  const selected = new Date(date);
  const day = selected.getDay(); // Sunday = 0
  const diffToMonday = day === 0 ? -6 : 1 - day;

  const monday = new Date(selected);
  monday.setHours(0, 0, 0, 0);
  monday.setDate(selected.getDate() + diffToMonday);

  const sunday = new Date(monday);
  sunday.setHours(23, 59, 59, 999);
  sunday.setDate(monday.getDate() + 6);

  return { monday, sunday };
};

const CreateExpense: React.FC = () => {
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [contractStartDate, setContractStartDate] = useState<Date | null>(null);
  const [contractEndDate, setContractEndDate] = useState<Date | null>(null);
  const [selectedWorkWeekDate, setSelectedWorkWeekDate] = useState<Date | null>(null);
  const [userRole] = useLocalStorage('userRole', null);
  const [selectedEmployee, setSelectedEmployee] = useState<IEmployeeDropdown | null>(null);
  const [selectedUserId, setSelectedUserId] = useState('');
  const [assignmentsUser, setAssignmentsUser] = useState<AssignmentItem[]>([]);

  const addExpense = useAddExpense();

  const [employeeSearch, setEmployeeSearch] = useState('');
  const [employees, setEmployees] = useState<IEmployeeDropdown[]>([]);
  const [employeeOptions, setEmployeeOptions] = useState<ICommonDropdownOption[]>([]);

  const [loadingEmployees, setLoadingEmployees] = useState(false);

  const [assignmentsLoading, setAssignmentsLoading] = useState(false);
  const [assignmentOptions, setAssignmentOptions] = useState<ICommonDropdownOption[]>([]);
  const [minPeriodStartDate, setMinPeriodStartDate] = useState<Date | null>(null);

  //   const addExpense = useAddExpense();
  const navigate = useNavigate();

  const assignmentOptionsWithBlank: ICommonDropdownOption[] = [
    {
      key: '',
      label: 'Select',
      value: '',
    },
    ...assignmentOptions,
  ];

  useEffect(() => {
    if (!employeeSearch || employeeSearch.length < 2) {
      setEmployeeOptions([]);
      setEmployees([]);
      return;
    }

    const timer = setTimeout(async () => {
      try {
        setLoadingEmployees(true);

        const data = await EmployeesService.getEmployeeDropdown(employeeSearch);
        setEmployees(data);

        setEmployeeOptions(
          data.map(emp => ({
            key: emp.employeeId,
            value: emp.employeeId,
            label: `${emp.firstName} ${emp.middleName ?? ''} ${emp.lastName}`.trim(),
          }))
        );
      } catch (error) {
        console.error('Employee dropdown search failed', error);
      } finally {
        setLoadingEmployees(false);
      }
    }, 400); // debounce

    return () => clearTimeout(timer);
  }, [employeeSearch]);

  useEffect(() => {
    if (!selectedEmployee) return;

    const fullName = `${selectedEmployee.firstName} ${selectedEmployee.middleName ?? ''} ${
      selectedEmployee.lastName
    }`.trim();

    // formik.setFieldValue(
    //   'notes',
    //   `Expense created for ${fullName}${selectedEmployee.email ? ` (${selectedEmployee.email})` : ''}`
    // );
  }, [selectedEmployee]);

  const formatDate = (date?: string | null) => {
    if (!date) return 'Open';
    return date.split('T')[0];
  };

  useEffect(() => {
    formik.setFieldValue('expenses', [
      {
        expenseDate: '',
        category: '',
        amount: '',
        receipt: null,
        details: '',
      },
    ]);
  }, [selectedWorkWeekDate]);

  const handleEmployeeSelect = async (employeeId: string) => {
    formik.setFieldValue('assignmentId', '');
    formik.setFieldValue('assignmentName', '');
    formik.setFieldValue('clientId', '');
    formik.setFieldValue('clientName', '');
    formik.setFieldValue('companyName', '');
    formik.setFieldValue('supplierName', '');
    formik.setFieldValue('jobTitle', '');
    formik.setFieldValue('hireType', '');
    formik.setFieldValue('billRate', '');
    formik.setFieldValue('payRate', '');
    formik.setFieldValue('currency', '');
    formik.setFieldValue('approverEmail', '');
    formik.setFieldValue('approverName', '');

    formik.setFieldValue('division', '');
    formik.setFieldValue('overtime', '');
    formik.setFieldValue('otCalculation', '');
    formik.setFieldValue('overtimeEligibility', '');

    formik.setFieldValue('markupPercent', '');
    formik.setFieldValue('w2Type', '');
    formik.setFieldValue('workMode', '');

    formik.setFieldValue('costCenterId', '');
    formik.setFieldValue('costCenterName', '');

    formik.setFieldValue('department', '');

    formik.setFieldValue('merId', '');
    formik.setFieldValue('purchaseOrder', '');

    formik.setFieldValue('billingCompany', '');

    formik.setFieldValue('billingAddress1', '');
    formik.setFieldValue('billingAddress2', '');

    formik.setFieldValue('billingCity', '');
    formik.setFieldValue('billingState', '');
    formik.setFieldValue('billingCounty', '');
    formik.setFieldValue('billingCountry', '');

    formik.setFieldValue('postalCode', '');
    formik.setFieldValue('assignmentStatus', '');

    formik.setFieldValue('billAddressSameAsWorkAddress', '');
    formik.setFieldValue('billingPostalCOde', '');
    formik.setFieldValue('glCode', '');
    formik.setFieldValue('externalReferenceId', '');

    const emp = employees.find(e => e.employeeId === employeeId) || null;
    if (!emp) return;

    setSelectedEmployee(emp);
    console.log('emp', emp);

    formik.setFieldValue('employeeId', emp.employeeId, true);
    formik.setFieldValue('userId', emp.userId, true);
    formik.setFieldValue('email', emp.email ?? '', true);
    setSelectedUserId(emp.userId);

    // 🔥 start loader
    setAssignmentsLoading(true);
    setAssignmentsUser([]);
    setAssignmentOptions([]);
    formik.setFieldValue('assignmentId', '');
    if (emp.personnelNumber) {
      try {
        const response = await InvoiceService.fetchAssignmentsByPersonalNumber({
          personnelNumber: emp.personnelNumber,
        });

        const items = response?.data?.vw_msd_jd_assignments?.items ?? [];

        setAssignmentsUser(items);
        const mappedOptions = items
          .filter((item: AssignmentItem) => item.EXPENSES_ENABLED === '1')
          .map((item: AssignmentItem) => ({
            key: item.ASSIGNMENT_ID,
            value: item.ASSIGNMENT_ID,
            label: `${item.JOBTITLE} (${item.ASSIGNMENT_ID}) - ${item.CLIENT_NAME} (${formatDate(
              item.CONTRACT_START_DATE
            )} - ${formatDate(item.CONTRACT_END_DATE)})`,
          }));

        setAssignmentOptions(mappedOptions);
      } catch (error) {
        console.error('Failed to fetch assignments', error);
        setAssignmentOptions([]);
      } finally {
        setAssignmentsLoading(false);
      }
    }

    // auto-hide employee dropdown
    setEmployeeSearch('');
    setEmployeeOptions([]);
    // setEmployees([]);
  };

  const validationSchema = yup.object({
    assignmentId: yup.string().required('Assignment is required'),
    workWeek: yup.date().nullable().required('Work Week is required'),
    expenses: yup
      .array()
      .of(
        yup.object({
          expenseDate: yup.string().required('Date of Expense is required'),
          category: yup.string().required('Category is required'),
          amount: yup.string().test('amount-or-miles-validation', function (this: yup.TestContext, value) {
            const parent = this.parent as { category?: string };
            const isMileage = parent.category === 'MILEAGE';
            const fieldName = isMileage ? 'Miles' : 'Amount';

            if (!value || !value.trim()) {
              return this.createError({
                message: `${fieldName} is required`,
              });
            }

            if (!/^\d+(\.\d{1,2})?$/.test(value.trim())) {
              return this.createError({
                message: `${fieldName} can have at most 2 decimal digits`,
              });
            }

            if (Number(value) <= 0) {
              return this.createError({
                message: `${fieldName} must be greater than 0`,
              });
            }

            return true;
          }),
        })
      )
      .min(1, 'At least one expense row is required'),
  });

  const formik = useFormik<ExpenseFormValues>({
    initialValues: {
      userId: '',
      employeeId: '',
      assignmentId: '',
      assignmentName: '',
      supplierName: '',
      jobTitle: '',
      hireType: '',
      periodStart: null,
      periodEnd: null,
      currency: '',
      totalUnits: '',
      totalHours: '',
      billRate: '',
      payRate: '',
      status: 'Submitted',
      attachments: [],
      approverEmail: '',
      approverName: '',
      notes: '',
      workWeek: null,

      // ✅ NEW FIELDS
      clientId: '',
      clientName: '',
      companyId: '',
      companyName: '',
      employmentCategory: '',
      billingContactName: '',
      workingCity: '',
      workingState: '',
      address1: '',
      payOvertimeExempt: '',
      overtimePayRate: '',
      hoursPerWeek: '',
      contractStartDate: null,
      contractEndDate: null,
      managerName: '',
      managerEmail: '',
      coApproverName: '',
      coApproverEmail: '',
      assignmentType: '',
      workerPayCompany: '',
      payModel: '',
      expensesEnabled: false,
      candidateCity: '',
      candidateState: '',
      assignmentStartDate: null,
      assignmentEndDate: null,

      // lat4est fields
      division: '',
      overtime: '',
      otCalculation: '',
      overtimeEligibility: '',

      markupPercent: '',
      w2Type: '',
      workMode: '',

      costCenterId: '',
      costCenter: '',

      department: '',

      merId: '',
      purchaseOrder: '',

      billingCompany: '',

      billingAddress1: '',
      billingAddress2: '',

      billingCity: '',
      billingState: '',
      billingCounty: '',
      billingCountry: '',

      postalCode: '',
      assignmentStatus: '',

      billAddressSameAsWorkAddress: '',

      billingPostalCOde: '',
      glCode: '',
      externalReferenceId: '',

      expenses: [
        {
          expenseDate: '',
          category: '',
          amount: '',
          receipt: null,
          details: '',
        },
      ],
    },
    validationSchema,
    validateOnMount: false,
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: async values => {
      try {
        const formData = new FormData();
        if (selectedWorkWeekDate) {
          const { monday, sunday } = getWorkWeekStartEnd(selectedWorkWeekDate);

          formData.append('weekStart', toISODate(monday));
          formData.append('weekEnd', toISODate(sunday));
        } else {
          formData.append('weekStart', '');
          formData.append('weekEnd', '');
        }
        formData.append('userId', values.userId || '');
        formData.append('assignmentId', values.assignmentId || '');
        formData.append('assignmentName', values.assignmentName || '');

        formData.append('supplierName', values.supplierName || '');
        formData.append('jobTitle', values.jobTitle || '');
        formData.append('hireType', values.hireType || '');
        formData.append('periodStart', values.periodStart ? toISODate(values.periodStart) : '');
        formData.append('periodEnd', values.periodEnd ? toISODate(values.periodEnd) : '');
        formData.append('status', values.status || '');
        formData.append('totalUnits', values.totalUnits || '');
        formData.append('totalHours', values.totalHours || '');
        formData.append('billRate', values.billRate || '');
        formData.append('payRate', values.payRate || '');
        formData.append('approverEmail', values.approverEmail || '');
        formData.append('approverName', values.approverName || '');
        formData.append('notes', values.notes || '');
        formData.append('currency', values.currency || '');

        // --- NEW FIELDS
        formData.append('clientId', values.clientId || '');
        formData.append('clientName', values.clientName || '');
        formData.append('companyName', values.companyName || '');
        formData.append('companyId', values.companyId || '');
        formData.append('employmentCategory', values.employmentCategory || '');
        formData.append('billingContactName', values.billingContactName || '');
        formData.append('workingCity', values.workingCity || '');
        formData.append('workingState', values.workingState || '');
        formData.append('address1', values.address1 || '');

        formData.append('payOvertimeExempt', values.payOvertimeExempt || '');

        formData.append('overtimePayRate', values.overtimePayRate ? String(values.overtimePayRate) : '');

        formData.append('hoursPerWeek', values.hoursPerWeek ? String(values.hoursPerWeek) : '');

        formData.append('contractStartDate', values.contractStartDate ? toISODate(values.contractStartDate) : '');

        formData.append('contractEndDate', values.contractEndDate ? toISODate(values.contractEndDate) : '');

        formData.append('managerName', values.managerName || '');
        formData.append('managerEmail', values.managerEmail || '');
        formData.append('coApproverName', values.coApproverName || '');
        formData.append('coApproverEmail', values.coApproverEmail || '');

        formData.append('assignmentType', values.assignmentType || '');
        formData.append('workerPayCompany', values.workerPayCompany || '');
        formData.append('payModel', values.payModel || '');

        formData.append('expensesEnabled', values.expensesEnabled ? '1' : '0');

        formData.append('candidateCity', values.candidateCity || '');
        formData.append('candidateState', values.candidateState || '');
        formData.append('assignmentStartDate', values.contractStartDate ? toISODate(values.contractStartDate) : '');
        if (values.contractEndDate) {
          formData.append('assignmentEndDate', values.contractEndDate ? toISODate(values.contractEndDate) : '');
        }

        // latest columns

        formData.append('divison', values.division || '');

        formData.append('overtime', values.overtime || '');
        formData.append('otCalculation', values.otCalculation || '');
        formData.append('overtimeEligibility', values.overtimeEligibility || '');

        formData.append('markupPercent', values.markupPercent || '');
        formData.append('w2Type', values.w2Type || '');
        formData.append('workMode', values.workMode || '');

        formData.append('costCenterId', values.costCenterId || '');
        formData.append('costCenter', values.costCenter || '');

        formData.append('department', values.department || '');

        formData.append('merId', values.merId || '');
        formData.append('purchaseOrder', values.purchaseOrder || '');

        formData.append('billingCompany', values.billingCompany || '');

        formData.append('billingAddress1', values.billingAddress1 || '');
        formData.append('billingAddress2', values.billingAddress2 || '');

        formData.append('billingCity', values.billingCity || '');
        formData.append('billingState', values.billingState || '');
        formData.append('billingCounty', values.billingCounty || '');
        formData.append('billingCountry', values.billingCountry || '');

        formData.append('postalCode', values.postalCode || '');
        formData.append('assignmentStatus', values.assignmentStatus || '');

        formData.append('billAddressSameAsWorkAddress', values.billAddressSameAsWorkAddress ? '1' : '0');
        formData.append('billingPostalCOde', values.billingPostalCOde || '');
        formData.append('glCode', values.glCode || '');
        formData.append('externalReferenceId', values.externalReferenceId || '');
        formData.append(
          'receipts',
          JSON.stringify(
            values.expenses.map(exp => {
              const base = {
                expenseDate: exp.expenseDate,
                category: exp.category,
                ...(exp.details ? { details: exp.details } : {}),
              };

              if (exp.category === 'MILEAGE') {
                return {
                  ...base,
                  miles: Number(exp.amount),
                };
              }

              return {
                ...base,
                amount: Number(exp.amount),
              };
            })
          )
        );

        values.expenses.forEach((exp, index) => {
          if (exp.receipt) {
            formData.append(`receiptAttachments_${index}`, exp.receipt);
          }
        });

        uploadedFiles.forEach(file => {
          formData.append('expenseAttachments', file);
        });

        await addExpense.mutateAsync({ expense: formData });
        navigate('/expenses');
      } catch (error) {
        console.error('Error during submission of Expense', error);
      }
    },
  });

  const dateOfExpenseOptions = useMemo(() => {
    if (!selectedWorkWeekDate) {
      return [{ key: '', value: '', label: 'Select day' }];
    }

    const startDate = formik.values.contractStartDate ? new Date(formik.values.contractStartDate) : null;

    const endDate = formik.values.contractEndDate ? new Date(formik.values.contractEndDate) : null;

    return [
      { key: '', value: '', label: 'Select day' },
      ...getWeekDateOptions(selectedWorkWeekDate, startDate, endDate),
    ];
  }, [selectedWorkWeekDate, formik.values.contractStartDate, formik.values.contractEndDate]);

  const handleAssignmentSelect = (assignmentId: string) => {
    const selected = assignmentsUser.find(a => a.ASSIGNMENT_ID === assignmentId);
    if (!selected) return;

    // ✅ RESET FIRST (very important)
    setSelectedWorkWeekDate(null);
    setUploadedFiles([]);

    formik.setFieldValue('workWeek', null);
    formik.setFieldValue('attachments', []);
    formik.setFieldValue('expenses', [
      {
        expenseDate: '',
        category: '',
        amount: '',
        receipt: null,
        details: '',
      },
    ]);

    setContractStartDate(selected.CONTRACT_START_DATE ? new Date(selected.CONTRACT_START_DATE) : null);
    setContractEndDate(selected.CONTRACT_END_DATE ? new Date(selected.CONTRACT_END_DATE) : null);

    formik.setValues(prev => ({
      ...prev,
      assignmentId: selected.ASSIGNMENT_ID,
      assignmentName: `${selected.JOBTITLE} (${selected.ASSIGNMENT_ID}) - ${selected.CLIENT_NAME}`,
      workerId: selected.EMPLOYEEID,

      supplierName: selected.WORKER_PAY_COMPANY ?? '',
      jobTitle: selected.JOBTITLE,
      hireType: selected.HIRETYPE,

      billRate: String(selected.BILL_RATE ?? ''),
      payRate: String(selected.PAY_RATE ?? ''),
      currency: selected.CURRENCY,

      approverName: selected.ASSIGNMENT_APPROVER_NAME,
      approverEmail: selected.APPROVER_EMAIL,

      companyId: selected.COMPANY_ID,
      clientId: selected.JOB_CLIENT_ID,
      clientName: selected.CLIENT_NAME,
      companyName: selected.COMPANY_NAME,

      employmentCategory: selected.EMPLOYMENT_CATEGORY ?? '',
      billingContactName: selected.BILLING_CONTACT_NAME ?? '',
      workingCity: selected.WORKING_CITY ?? '',
      workingState: selected.WORKING_STATE ?? '',
      address1: selected.ADDRESS1 ?? '',

      payOvertimeExempt: selected.PAY_OVERTIME_EXEMPT ?? '',

      overtimePayRate: selected.OVERTIME_PAY_RATE !== undefined ? parseFloat(selected.OVERTIME_PAY_RATE) : '',

      hoursPerWeek: selected.HOURSPERWEEK !== undefined ? parseFloat(selected.HOURSPERWEEK) : '',

      contractStartDate: selected.CONTRACT_START_DATE || null,
      contractEndDate: selected.CONTRACT_END_DATE || null,

      managerName: selected.MANAGER_NAME ?? '',
      managerEmail: selected.MANAGER_EMAIL ?? '',
      coApproverName: selected.BACKUP_APPROVER_NAME ?? '',
      coApproverEmail: selected.BACKUP_APPROVER_EMAIL ?? '',

      assignmentType: selected.ASSIGNMENT_TYPE ?? '',
      workerPayCompany: selected.WORKER_PAY_COMPANY ?? '',
      payModel: selected.PAY_MODEL ?? '',

      expensesEnabled: selected.EXPENSES_ENABLED === '1',

      candidateCity: selected.CANDIDATE_CITY ?? '',
      candidateState: selected.CANDIDATE_STATE ?? '',

      division: selected.DIVISION ?? '',
      overtime: selected.OVERTIME ?? '',
      otCalculation: selected.OT_CALCULATION ?? '',
      overtimeEligibility: selected.OVERTIMEELIGIBILITY ?? '',

      markupPercent: selected.MARKUP_PERCENT ?? '',
      w2Type: selected.W2_TYPE ?? '',
      workMode: selected.WORKMODE ?? '',

      costCenterId: selected.COST_CENTER_ID ?? '',
      costCenter: selected.COST_CENTER_NAME ?? '',

      department: selected.Departments ?? '',

      merId: selected.MERID ?? '',
      purchaseOrder: selected.PURCHASE_ORDER ?? '',

      billingCompany: selected.BILLING_COMPANY ?? '',

      billingAddress1: selected.BILLING_ADDRESS1 ?? '',
      billingAddress2: selected.BILLING_ADDRESS2 ?? '',

      billingCity: selected.BILLING_CITY ?? '',
      billingState: selected.BILLING_STATE ?? '',
      billingCounty: selected.BILLING_COUNTY ?? '',
      billingCountry: selected.BILLING_COUNTRY ?? '',

      postalCode: selected.POSTAL_CODE ?? '',
      assignmentStatus: selected.ASSIGNMENT_STATUS ?? '',

      billAddressSameAsWorkAddress: selected.BILL_ADDRESS_SAME_AS_WORK_ADDRESS ?? '',
      billingPostalCOde: selected.BILLING_ZIP ?? '',
      glCode: selected.GL_CODE ?? '',
      externalReferenceId: selected.VMS_ID ?? '',
    }));
  };

  const applyAssignmentToForm = (assignment: any) => {
    formik.setFieldValue('workerId', assignment.EMPLOYEEID ?? '');
    formik.setFieldValue('assignmentId', assignment.ASSIGNMENT_ID ?? '');

    if (assignment.PAY_START_DATE) {
      const payStart = new Date(assignment.PAY_START_DATE);
      console.log('payStart', payStart);
      setMinPeriodStartDate(payStart);

      // If already selected periodStart is before payStart, reset it
      if (formik.values.periodStart && new Date(formik.values.periodStart) < payStart) {
        formik.setFieldValue('periodStart', null);
      }
    } else {
      setMinPeriodStartDate(null);
    }

    formik.setFieldValue(
      'assignmentName',
      `${assignment.JOBTITLE} (${assignment.ASSIGNMENT_ID}) - ${assignment.CLIENT_NAME}`
    );

    formik.setFieldValue('clientId', assignment.JOB_CLIENT_ID ?? '');
    formik.setFieldValue('clientName', assignment.CLIENT_NAME ?? '');

    // If you don’t have these from API yet, keep empty for now

    formik.setFieldValue('companyId', assignment.COMPANY_ID ?? '');
    formik.setFieldValue('companyName', assignment.COMPANY_NAME ?? '');
    formik.setFieldValue('supplierName', assignment.WORKER_PAY_COMPANY ?? '');

    formik.setFieldValue('jobTitle', assignment.JOBTITLE ?? '');
    formik.setFieldValue('hireType', assignment.HIRETYPE ?? '');

    // formik.setFieldValue('billRate', String(assignment.BILL_RATE ?? ''));
    // formik.setFieldValue('payRate', String(assignment.PAY_RATE ?? ''));

    formik.setFieldValue('currency', assignment.CURRENCY ?? 'USD');

    formik.setFieldValue('approverEmail', assignment.APPROVER_EMAIL ?? '');
    formik.setFieldValue('approverName', assignment.ASSIGNMENT_APPROVER_NAME ?? '');

    formik.setFieldValue('division', assignment.DIVISION ?? '');
    formik.setFieldValue('overtime', assignment.OVERTIME ?? '');
    formik.setFieldValue('otCalculation', assignment.OT_CALCULATION ?? '');
    formik.setFieldValue('overtimeEligibility', assignment.OVERTIMEELIGIBILITY ?? '');

    formik.setFieldValue('markupPercent', assignment.MARKUP_PERCENT ?? '');
    formik.setFieldValue('w2Type', assignment.W2_TYPE ?? '');
    formik.setFieldValue('workMode', assignment.WORKMODE ?? '');

    formik.setFieldValue('costCenterId', assignment.COST_CENTER_ID ?? '');
    formik.setFieldValue('costCenter', assignment.COST_CENTER_NAME ?? '');

    formik.setFieldValue('department', assignment.Departments ?? '');

    formik.setFieldValue('merId', assignment.MERID ?? '');
    formik.setFieldValue('purchaseOrder', assignment.PURCHASE_ORDER ?? '');

    formik.setFieldValue('billingCompany', assignment.BILLING_COMPANY ?? '');

    formik.setFieldValue('billingAddress1', assignment.BILLING_ADDRESS1 ?? '');
    formik.setFieldValue('billingAddress2', assignment.BILLING_ADDRESS2 ?? '');

    formik.setFieldValue('billingCity', assignment.BILLING_CITY ?? '');
    formik.setFieldValue('billingState', assignment.BILLING_STATE ?? '');
    formik.setFieldValue('billingCounty', assignment.BILLING_COUNTY ?? '');
    formik.setFieldValue('billingCountry', assignment.BILLING_COUNTRY ?? '');

    formik.setFieldValue('postalCode', assignment.POSTAL_CODE ?? '');

    formik.setFieldValue('billAddressSameAsWorkAddress', assignment.BILL_ADDRESS_SAME_AS_WORK_ADDRESS ?? '');
    formik.setFieldValue('billingPostalCOde', assignment.BILLING_ZIP ?? '');
    formik.setFieldValue('glCode', assignment.GL_CODE ?? '');
    formik.setFieldValue('externalReferenceId', assignment.VMS_ID ?? '');

    if (assignment.CONTRACT_START_DATE) {
      const start = new Date(assignment.CONTRACT_START_DATE);
      setContractStartDate(start);
    } else {
      setContractStartDate(null);
    }

    if (assignment.CONTRACT_END_DATE) {
      const end = new Date(assignment.CONTRACT_END_DATE);
      setContractEndDate(end);
    } else {
      setContractEndDate(null);
    }
  };

  const fileInputRef = React.useRef<HTMLInputElement | null>(null);

  const handleFileUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files || []);
    const updatedFiles = [...uploadedFiles, ...files];

    setUploadedFiles(updatedFiles);
    formik.setFieldValue('attachments', updatedFiles);
  };

  const handleFiles = (files: File[]) => {
    const updatedFiles = [...uploadedFiles, ...files];

    setUploadedFiles(updatedFiles);

    // Update Formik attachments
    formik.setFieldValue('attachments', updatedFiles);
  };

  const handleFileDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();

    const files = Array.from(event.dataTransfer.files || []);

    handleFiles(files);
  };

  const handleRemoveFile = (index: number) => {
    const updatedFiles = uploadedFiles.filter((_, i) => i !== index);
    setUploadedFiles(updatedFiles);
    formik.setFieldValue('attachments', updatedFiles);
  };

  const addExpenseRow = () => {
    formik.setFieldValue('expenses', [
      ...formik.values.expenses,
      {
        expenseDate: '',
        category: '',
        amount: '',
        receipt: null,
        details: '',
      },
    ]);
  };

  const removeExpenseRow = (index: number) => {
    const updatedExpenses = formik.values.expenses.filter((_, i) => i !== index);
    formik.setFieldValue('expenses', updatedExpenses);
  };

  return (
    <Container>
      {/* {<FullScreenLoading />} */}
      {(loadingEmployees || assignmentsLoading) && <FullScreenLoading />}

      <SearchLink>
        <Link to="/expenses">Search Expenses</Link>
      </SearchLink>

      <HeaderItemLeft>
        <NavTextLink to={-1 as any}>
          <ArrowBack src={Arrow} />
        </NavTextLink>
        <PageTitle>Create Expense Sheet</PageTitle>
      </HeaderItemLeft>

      <CardContainer>
        <HelpForm>
          <ModuleLine style={{ display: 'flex', gap: '36px', marginBottom: '-10px' }}>
            <FormInputWrapper
              style={{
                position: 'relative',
                width: '100%',
                overflow: 'visible',
                maxHeight: 'none',
              }}
            >
              <CommonInput
                label="Employee *"
                placeholder="Search employee"
                value={selectedEmployee ? `${selectedEmployee.firstName} ${selectedEmployee.lastName}` : employeeSearch}
                onChange={e => {
                  setSelectedEmployee(null);
                  setEmployeeSearch(e.target.value);
                }}
                style={{
                  width: '100%',
                  borderRadius: '7px',
                  border: '1px solid #ccc',
                }}
                autoComplete="new-password"
              />

              {employeeOptions.length > 0 && (
                <div
                  style={{
                    position: 'absolute',
                    top: '70px',
                    width: '100%',
                    zIndex: 10,
                    background: '#fff',
                    border: '1px solid #ccc',
                    borderRadius: '7px',
                    maxHeight: '220px',
                    overflowY: 'auto',
                  }}
                >
                  {employeeOptions.map(option => (
                    <div
                      key={option.value}
                      onClick={() => handleEmployeeSelect(option.value as string)}
                      style={{
                        padding: '10px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #eee',
                      }}
                    >
                      {option.label}
                    </div>
                  ))}
                </div>
              )}

              <FormErrorWrap
                errorMessage={formik.errors.userId as string}
                visible={!!(formik.touched.userId && formik.errors.userId)}
              />
            </FormInputWrapper>
          </ModuleLine>

          <ModuleLine style={{ display: 'flex', gap: '36px', marginBottom: '-10px' }}>
            <FormInputWrapper style={{ flex: '1', maxWidth: '108%' }}>
              {assignmentsLoading ? (
                <FullScreenLoading />
              ) : (
                <CommonDropdown
                  label="Assignment *"
                  id="assignmentId"
                  name="assignmentId"
                  options={assignmentOptionsWithBlank}
                  value={formik.values.assignmentId}
                  setValue={handleAssignmentSelect}
                  selectStyle={{
                    width: '100%',
                    height: '35px',
                    borderRadius: '7px',
                    border: '1px solid #ccc',
                  }}
                  disabled={!selectedEmployee || assignmentOptions.length === 0}
                />
              )}

              <FormErrorWrap
                errorMessage={formik.errors.assignmentId as string}
                visible={!!(formik.submitCount > 0 && formik.errors.assignmentId)}
              />
            </FormInputWrapper>

            <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
              <WorkWeekDatepicker
                initialDate={selectedWorkWeekDate}
                onDateChange={date => {
                  setSelectedWorkWeekDate(date);
                  formik.setFieldValue('workWeek', date);
                }}
                minDate={contractStartDate}
                maxDate={contractEndDate}
              />
              <FormErrorWrap
                errorMessage={formik.errors.workWeek as string}
                visible={!!(formik.submitCount > 0 && formik.errors.workWeek)}
              />
            </FormInputWrapper>
          </ModuleLine>

          {formik.values.expenses.map((expense, index) => (
            <ModuleLine key={index} style={{ display: 'flex', gap: '36px', alignItems: 'flex-start' }}>
              <span style={{ fontSize: '1.6rem', minWidth: '20px' }}>{index + 1}</span>

              <FormInputWrapper style={{ flex: '1', maxWidth: '108%' }}>
                <CommonDropdown
                  label={index === 0 ? 'Date of Expense *' : ''}
                  id={`expenses.${index}.expenseDate`}
                  name={`expenses.${index}.expenseDate`}
                  options={dateOfExpenseOptions}
                  value={expense.expenseDate}
                  setValue={(value: string) => formik.setFieldValue(`expenses.${index}.expenseDate`, value)}
                  selectStyle={{
                    width: '100%',
                    height: '35px',
                    borderRadius: '7px',
                    border: '1px solid #ccc',
                  }}
                />
                <FormErrorWrap
                  errorMessage={(formik.errors.expenses?.[index] as FormikErrors<ExpenseRow>)?.expenseDate as string}
                  visible={
                    !!(
                      formik.submitCount > 0 &&
                      (formik.errors.expenses?.[index] as FormikErrors<ExpenseRow>)?.expenseDate
                    )
                  }
                />
              </FormInputWrapper>

              <FormInputWrapper style={{ flex: '1', maxWidth: '108%' }}>
                <CommonDropdown
                  label={index === 0 ? 'Category *' : ''}
                  id={`expenses.${index}.category`}
                  name={`expenses.${index}.category`}
                  options={expenseCategories.map(c => ({
                    key: c.name,
                    value: c.name,
                    label: c.displayName,
                  }))}
                  value={expense.category}
                  setValue={(value: string) => formik.setFieldValue(`expenses.${index}.category`, value)}
                  selectStyle={{
                    width: '100%',
                    height: '35px',
                    borderRadius: '7px',
                    border: '1px solid #ccc',
                  }}
                />
                <FormErrorWrap
                  errorMessage={(formik.errors.expenses?.[index] as FormikErrors<ExpenseRow>)?.category as string}
                  visible={
                    !!(
                      formik.submitCount > 0 && (formik.errors.expenses?.[index] as FormikErrors<ExpenseRow>)?.category
                    )
                  }
                />
              </FormInputWrapper>

              <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
                <label style={{ display: index === 0 ? 'block' : 'none', marginBottom: '-2px', fontSize: '1.6rem' }}>
                  Amount *
                </label>

                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span
                    style={{
                      marginRight: '4px',
                      fontSize: '1.4rem',
                      marginTop: '8px',
                    }}
                  >
                    {formik?.values?.expenses?.[index]?.category === 'MILEAGE'
                      ? ''
                      : currencySymbol(formik?.values?.currency) || '$'}
                  </span>

                  <CommonInput
                    id={`expenses.${index}.amount`}
                    name={`expenses.${index}.amount`}
                    label=""
                    placeholder={formik?.values?.expenses?.[index]?.category === 'MILEAGE' ? 'Miles' : 'Money'}
                    value={expense.amount}
                    onChange={e => formik.setFieldValue(`expenses.${index}.amount`, e.target.value)}
                    autoComplete="off"
                    type="Number"
                    style={commonFieldStyle}
                  />
                  <span
                    style={{
                      marginLeft: '4px',
                      fontSize: '1.4rem',
                      marginTop: '8px',
                    }}
                  >
                    {formik.values.expenses[index].category === 'MILEAGE' ? 'Miles' : ''}
                  </span>
                </div>

                <FormErrorWrap
                  errorMessage={(formik.errors.expenses?.[index] as FormikErrors<ExpenseRow>)?.amount as string}
                  visible={
                    !!(formik.submitCount > 0 && (formik.errors.expenses?.[index] as FormikErrors<ExpenseRow>)?.amount)
                  }
                />
              </FormInputWrapper>

              <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
                <UploadLink
                  label={index === 0 ? 'Receipt' : ''}
                  actionText={expense.receipt ? 'Replace' : 'Attach'}
                  onFileSelect={file => formik.setFieldValue(`expenses.${index}.receipt`, file)}
                />
              </FormInputWrapper>

              <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
                <CommonInput
                  id={`expenses.${index}.details`}
                  name={`expenses.${index}.details`}
                  label={index === 0 ? 'Details' : ''}
                  placeholder="Describe expense"
                  value={expense.details}
                  onChange={event => formik.setFieldValue(`expenses.${index}.details`, event.target.value)}
                  autoComplete="off"
                  style={{
                    width: '100%',
                    borderRadius: '7px',
                    border: '1px solid #ccc',
                    boxSizing: 'border-box',
                  }}
                />
              </FormInputWrapper>

              <FormInputWrapper style={{ flex: '0 0 auto', marginTop: `${index === 0 ? '20px' : '0'}` }}>
                {formik.values.expenses.length > 1 ? (
                  <OutlinedButton type="button" onClick={() => removeExpenseRow(index)}>
                    Remove
                  </OutlinedButton>
                ) : null}
              </FormInputWrapper>
            </ModuleLine>
          ))}

          <FormInputWrapper style={{ flex: '0 0 100%', marginBottom: '15px' }}>
            <RegularButton type="button" onClick={addExpenseRow}>
              Add
            </RegularButton>
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 100%', marginBottom: '5px', position: 'relative' }}>
            <label
              htmlFor="fileUpload"
              style={{
                display: 'block',
                marginBottom: '5px',
                fontSize: '16px',
                color: '#222247',
              }}
            >
              Attachments *
            </label>

            <input
              ref={fileInputRef}
              id="fileUpload"
              name="Attachment"
              type="file"
              multiple
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />

            <div
              style={{
                width: '100%',
                height: '136px',
                border: '1px solid #ccc',
                borderRadius: '7px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                position: 'relative',
                boxSizing: 'border-box',
              }}
              onClick={handleFileUploadClick}
              onDragOver={event => {
                event.preventDefault();
                event.stopPropagation();
              }}
              onDrop={handleFileDrop}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  font: '18px/27px Biotif',
                }}
              >
                <span
                  style={{
                    color: '#4A4BA9',
                    fontWeight: 'bold',
                    marginRight: '5px',
                  }}
                >
                  Add files
                </span>
                <span
                  style={{
                    color: '#222247',
                    opacity: 0.5,
                  }}
                >
                  Or drop files here
                </span>
              </div>
            </div>

            <FormErrorWrap
              errorMessage={formik.errors.attachments as string}
              visible={!!(formik.touched.attachments || formik.submitCount > 0) && !!formik.errors.attachments}
            />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 100%', marginTop: '0px', marginBottom: '20px' }}>
            <div
              style={{
                width: '55%',
                marginTop: '0px',
                paddingTop: '0px',
                borderRadius: '7px',
              }}
            >
              {uploadedFiles.map((file, index) => (
                <div key={`${file.name}-${index}`} style={{ display: 'flex', alignItems: 'center', marginTop: '0px' }}>
                  <a
                    href={URL.createObjectURL(file)}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: '#4A4BA9',
                      textDecoration: 'none',
                      marginRight: '10px',
                      fontSize: '12px',
                    }}
                  >
                    {file.name}
                  </a>

                  <span
                    onClick={() => handleRemoveFile(index)}
                    style={{
                      color: '#4A4BA9',
                      cursor: 'pointer',
                      fontSize: '12px',
                    }}
                  >
                    ✕
                  </span>
                </div>
              ))}
            </div>
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 100%', marginBottom: '-10px' }}>
            <label htmlFor="notes" style={{ display: 'block', marginBottom: '5px' }}>
              Notes
            </label>

            <textarea
              id="notes"
              name="notes"
              placeholder="Notes"
              value={formik.values.notes}
              onChange={event => formik.setFieldValue('notes', event.target.value)}
              style={{
                width: '100%',
                height: '136px',
                borderRadius: '7px',
                border: '1px solid #ccc',
                boxSizing: 'border-box',
                padding: '10px',
                resize: 'none',
                fontSize: '14px',
                textAlign: 'left',
                verticalAlign: 'top',
              }}
            />

            <FormErrorWrap
              errorMessage={formik.errors.notes as string}
              visible={!!(formik.touched.notes && formik.errors.notes)}
            />
          </FormInputWrapper>

          <FormInputWrapper
            style={{
              flex: '0 0 100%',
              display: 'flex',
              justifyContent: 'flex-start',
              marginBottom: '5px',
            }}
          >
            <OutlinedButton onClick={() => navigate('/expenses')}>Cancel</OutlinedButton>

            <OutlinedButton
              type="button"
              onClick={() => {
                formik.setFieldValue('status', 'Draft');
                formik.handleSubmit();
              }}
              //   disabled={formik.isSubmitting || addExpense.isLoading}
            >
              Draft
            </OutlinedButton>

            <RegularButton
              type="button"
              onClick={() => {
                formik.setFieldValue('status', 'Submitted');
                formik.handleSubmit();
              }}
              disabled={formik.isSubmitting || addExpense.isLoading}
            >
              Submit
            </RegularButton>
          </FormInputWrapper>
        </HelpForm>
      </CardContainer>
    </Container>
  );
};

export default CreateExpense;
